import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import { Box, Stack, Typography } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { Navigate } from 'react-router';
import { PublicRegistrationState, WEB_ROUTES } from '@lsc/shared';
import { LoadingState } from '../../components/LoadingState';
import { registrationStatusQuery } from '../api';
import { ErrorState } from '../components/ErrorState';
import { PageHeading } from '../components/PageHeading';

/** `/success` (§52) – only rendered for ACTIVE; any other state goes back to `/status`. */
export function SuccessPage() {
  const query = useQuery(registrationStatusQuery);

  if (query.isPending) return <LoadingState label="Status wird geladen …" />;
  if (query.isError) return <ErrorState error={query.error} onRetry={() => void query.refetch()} />;
  if (query.data.registration.state !== PublicRegistrationState.ACTIVE) {
    return <Navigate to={WEB_ROUTES.registrationStatus} replace />;
  }

  return (
    <Stack spacing={3}>
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
        <CheckCircleOutlineIcon
          aria-hidden="true"
          color="success"
          sx={{ mt: 0.75, fontSize: 32 }}
        />
        <PageHeading>Ihr Zugang wurde erfolgreich aktiviert.</PageHeading>
      </Box>
      <Typography>Sie erhalten alle weiteren Informationen per E-Mail.</Typography>
      <Typography color="text.secondary">Sie können diese Seite jetzt schließen.</Typography>
    </Stack>
  );
}
